/**
 * LeftOverlay - full-screen terminal state after a voluntary Leave (the
 * meeting toolbar's red button). Unlike RemovedOverlay there IS a way back:
 * the local session token was cleared, so Rejoin reloads and goes back
 * through the normal entry gate (invite claim / waiting room / open access).
 */
import { useStore } from 'zustand';
import { LogOut } from 'lucide';
import { hudStore } from '../../state/hudStore';
import { Icon } from './Icon';
import type { LucideIconNode } from '../../utils/iconCanvas';

export function LeftOverlay() {
  const shown = useStore(hudStore, (s) => s.leftOverlay);
  if (!shown) return null;

  return (
    <div
      id="left-overlay"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(10,10,14,0.96)',
        zIndex: 20000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'sans-serif',
        color: '#fff',
        textAlign: 'center',
        padding: '24px',
      }}
    >
      <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'center' }}>
        <Icon icon={LogOut as unknown as LucideIconNode} size={44} />
      </div>
      <h2 style={{ margin: '0 0 10px', fontSize: '24px' }}>You left the session</h2>
      <p style={{ margin: '0 0 20px', color: '#bbb', fontSize: '15px', maxWidth: '420px' }}>
        Thanks for visiting. You can rejoin at any time.
      </p>
      <button
        type="button"
        onClick={() => location.reload()}
        style={{
          padding: '10px 28px',
          borderRadius: '10px',
          border: 'none',
          background: 'rgba(25,118,210,0.95)',
          color: '#fff',
          fontSize: '15px',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Rejoin
      </button>
    </div>
  );
}
